// NATSU Intelligence — shared site data & helpers

export const NAV_ITEMS = [
  { label: "Platform", id: "platform" },
  { label: "Architecture", id: "architecture" },
  { label: "Product", id: "product" },
  { label: "Governance", id: "governance" },
  { label: "Value", id: "value" },
  { label: "Pilot Journey", id: "roadmap" },
  { label: "About", id: "about" },
];

// Section ids in page order (used for active-section tracking)
export const SECTION_IDS = [
  "hero",
  "problem",
  "why-now",
  "platform",
  "architecture",
  "product",
  "workflow",
  "governance",
  "value",
  "why-natsu",
  "roadmap",
  "about",
  "pilot",
];

const NAV_OFFSET = 78;

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -NAV_OFFSET });
  } else {
    const y = el.getBoundingClientRect().top + window.scrollY - NAV_OFFSET;
    window.scrollTo({ top: y, behavior: "smooth" });
  }
}
